import { APIAuthService, APIService } from "./APIService"

const login = state => APIService.post<null, {
  role: string,
  status: string
  username: string
  token: string
}>(`/login`, state)

const verify = () => APIAuthService.post<null, {
  status: string
}>(`/verify`)

const register = state => APIService.post<null, {
  id: string,
  role: string,
  status: string
  username: string
  token: string
}>(`/register`, state)

const resendCode = () => APIAuthService.get<null, null>(`/users/:userId/resend-code`)
const verifyCode = code => APIAuthService.get<null, null>(`/users/:userId/verify?code=${code}`)

export const AuthService = {
  login,
  verify,
  register,
  resendCode,
  verifyCode,
}
